export default {
  autoUpdate: 'Automatisch aktualisieren (alle {0})',
  updateInterval: 'Aktualisierungsintervall',
  lastUpdate: 'Letzte Aktualisierung',
  nextUpdate: 'Nächste Aktualisierung in {0}',
};
